module.exports = __webpack_public_path__ + "img/profile-art-4.95a2ba6.svg";